import { Drawer, List, Table } from "antd";
import { Dropdown as AntdDropDown } from "antd";
import React, { useEffect, useState } from "react";
import { Dropdown, TextComponent } from "../../../../components";
import styles from "./moduleControl.module.css";
import md1 from "../../../../assets/images/staticImages/c1.png";
import md2 from "../../../../assets/images/staticImages/c2.png";
import md3 from "../../../../assets/images/staticImages/c3.png";
import md4 from "../../../../assets/images/staticImages/c4.png";
import md5 from "../../../../assets/images/staticImages/c5.png";
import m1 from "../../../../assets/images/staticImages/md1.png";
import m2 from "../../../../assets/images/staticImages/md2.png";
import m3 from "../../../../assets/images/staticImages/md3.png";
import imagePlaceholder from "../../../../assets/images/imageplace.jpg";
import Switch from "../../../../components/Switch/Switch";
import { SlOptionsVertical } from "react-icons/sl";
import { AiFillPlusCircle } from "react-icons/ai";
import Card from "../../../../components/Card/Card";
import { IoClose } from "react-icons/io5";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import ScheduleModal from "../../AssetsManagement/ScheduleModal/ScheduleModal";
import EditScheduleModal from "../../AssetsManagement/ScheduleModal/EditScheduleModal";
import { AssetsMiddleware } from "../../../../Store/Middlewares/AssetsMiddleware";
import { useDispatch, useSelector } from "react-redux";

const dummydata = [
  {
    id: 1,
    key: "01",
    module: { image: m1, name: "Phoenix Immobilizer N16" },
    car: { image: md1, name: "Honda" },
    status: "Active",
    schedule: [
      {
        title: "Immobilizer Activation",
        ferquency: "Daily",
        isImobilized: true,
        time: "10:00 AM",
      },
      {
        title: "High Security mode",
        ferquency: "Daily",
        isImobilized: false,
        time: "10:00 PM",
      },
      {
        title: "Immobilizer Health Check",
        ferquency: "Monday",
        isImobilized: true,
        time: "10:00 AM",
      },
    ],
  },
  {
    id: 2,
    key: "02",
    module: { image: m2, name: "Phoenix Immobilizer N16" },
    car: { image: md2, name: "Toyota" },
    status: "Active",
    schedule: [
      {
        title: "Immobilizer Activation",
        ferquency: "Daily",
        isImobilized: true,
        time: "10:00 AM",
      },
      {
        title: "High Security mode",
        ferquency: "Daily",
        isImobilized: false,
        time: "10:00 PM",
      },
      {
        title: "Immobilizer Health Check",
        ferquency: "Monday",
        isImobilized: true,
        time: "10:00 AM",
      },
    ],
  },

  {
    id: 3,
    key: "03",
    module: { image: md3, name: "Phoenix Immobilizer N16" },
    car: { image: md3, name: "Ford" },
    status: "Deactivate",
    schedule: [
      {
        title: "Immobilizer Activation",
        ferquency: "Daily",
        isImobilized: true,
        time: "10:00 AM",
      },
      {
        title: "High Security mode",
        ferquency: "Daily",
        isImobilized: false,
        time: "10:00 PM",
      },
      {
        title: "Immobilizer Health Check",
        ferquency: "Monday",
        isImobilized: true,
        time: "10:00 AM",
      },
    ],
  },
  {
    id: 4,
    key: "04",
    module: { image: m2, name: "Phoenix Immobilizer N16" },
    car: { image: md4, name: "Chevrolet" },
    status: "Active",
    schedule: [
      {
        title: "Immobilizer Activation",
        ferquency: "Daily",
        isImobilized: true,
        time: "10:00 AM",
      },
      {
        title: "High Security mode",
        ferquency: "Daily",
        isImobilized: false,
        time: "10:00 PM",
      },
      {
        title: "Immobilizer Health Check",
        ferquency: "Monday",
        isImobilized: true,
        time: "10:00 AM",
      },
    ],
  },
  {
    id: 5,
    key: "05",
    module: { image: m2, name: "Phoenix Immobilizer N16" },
    car: { image: md5, name: "Jeep" },
    status: "Deactivate",
    schedule: [
      {
        title: "Immobilizer Activation",
        ferquency: "Daily",
        isImobilized: true,
        time: "10:00 AM",
      },
      {
        title: "High Security mode",
        ferquency: "Daily",
        isImobilized: false,
        time: "10:00 PM",
      },
      {
        title: "Immobilizer Health Check",
        ferquency: "Monday",
        isImobilized: true,
        time: "10:00 AM",
      },
    ],
  },

  {
    id: 6,
    key: "06",
    module: { image: m2, name: "Phoenix Immobilizer N16" },
    car: { image: md3, name: "Nissan" },
    status: "Active",
    schedule: [
      {
        title: "Immobilizer Activation",
        ferquency: "Daily",
        isImobilized: true,
        time: "10:00 AM",
      },
      {
        title: "High Security mode",
        ferquency: "Daily",
        isImobilized: false,
        time: "10:00 PM",
      },
      {
        title: "Immobilizer Health Check",
        ferquency: "Monday",
        isImobilized: true,
        time: "10:00 AM",
      },
    ],
  },
];

// const cars = [
//   "Honda",
//   "Toyota",
//   "Ford",
//   "Chevrolet",
//   "Jeep",
//   "Nissan",
//   "BMW",
//   "Mercedes-Benz",
//   "Audi",
// ];

const ModuleControl = () => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  // const [carFilter, setCarFilter] = useState(cars[0]);
  const [open, setOpen] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [editScheduleModal, setEditScheduleModal] = useState(false);
  const [schedule, setSchedule] = useState({});

  const SingleAssets = useSelector(
    (state) => state.AssetsReducer.getSingleAssets,
  );
  // console.log("///////////////////", SingleAssets);

  const getData = (name) => {
    dispatch(AssetsMiddleware.getSingleAssets(name)).then((data) => {});
  };
  useEffect(() => {
    getData();
  }, []);
  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      render: (text, data, index) => (
        <div>
          <TextComponent text={index + 1} className={styles.versionText} />
        </div>
      ),
    },
    {
      title: "Module",
      dataIndex: "module",
      key: "module",
      render: (item, data) => (
        <div className={styles.module}>
          <img
            src={data?.device_image ? data?.device_image : m1}
            className={styles.moduleImg}
          />
          <TextComponent
            text={data?.device_name ? data?.device_name : "--"}
            className={styles.moduletext}
          />
        </div>
      ),
    },
    {
      title: "Make",
      dataIndex: "car",
      key: "car",
      render: (item, data) => (
        <div className={styles.module}>
          <img
            src={data?.image ? data?.image : imagePlaceholder}
            className={styles.moduleImg}
          />
          <TextComponent
            text={data?.name ? data?.name : "--"}
            className={styles.moduletext}
          />
        </div>
      ),
    },
    // {
    //   title: "Module status",
    //   dataIndex: ".",
    //   key: ".",
    //   render: (text) => {
    //     return (
    //       <div className={styles.carDiv}>
    //         <Dropdown
    //           value={text}
    //           inputClass={styles.carDropDown}
    //           options={[
    //             { id: 1, value: "Active" },
    //             // { id: 2, value: "Deactivate" },
    //           ]}
    //         />
    //       </div>
    //     );
    //   },
    // },
    {
      title: "License Plate",
      dataIndex: "license_no",
      key: "license_no",
      render: (text) => (
        <div className={styles.carDiv}>
          <TextComponent text={text} className={styles.text} />
        </div>
      ),
    },
    {
      title: "VIN",
      dataIndex: "vin_no",
      key: "vin_no",
      render: (text) => {
        const lastEight = text ? text.toString().slice(-8) : "";

        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={lastEight} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Asset status",
      dataIndex: "status",
      key: "status",
      style: { width: "10%" },
      render: (text) => {
        return (
          <div className={styles.assetStaus}>
            <Switch
              size="small"
              isChecked={text == "drive" ? true : false}
              disabled
            />
            <TextComponent
              text={text == "immobilized" ? "Immobilized" : "Drive"}
              //   className={styles.moduletext}
            />
          </div>
        );
      },
    },
    // {
    //   title: "Schedule",
    //   dataIndex: "schedule",
    //   key: "schedule",
    //   render: (item) => (
    //     <div
    //       className={styles.module}
    //       onClick={() => {
    //         setOpen(true);
    //         setSchedule(item);
    //       }}
    //     >
    //       {/* <img src={item?.image} className={styles.moduleImg} /> */}
    //       <TextComponent text={"View"} className={styles.viewText} />
    //     </div>
    //   ),
    // },
  ];

  const items3 = [
    {
      key: "3",
      label: <a onClick={() => setEditScheduleModal(true)}>Edit Schedule</a>,
    },
    {
      key: "4",
      label: <a>Delete</a>,
    },
  ];

  // const rendercars = (item) => {
  //   return (
  //     <TextComponent
  //       onClick={() => setCarFilter(item)}
  //       text={item}
  //       className={carFilter == item ? styles.carTextActive : styles.carText}
  //     />
  //   );
  // };

  const renderItemScedule = (item) => {
    // console.log(item);
    return (
      <div className={`${styles.scheduleCont}`}>
        <div>
          <TextComponent text={item?.title} className={styles.heading} />
          <div className={styles.scheduleLeftCont}>
            <TextComponent text={item?.ferquency} className={styles.text} />
            <TextComponent text={item?.time} className={styles.scheduleTime} />
            <Switch
              isChecked={item.isImobilized}
              size="small"
              // style={
              //   item.isImobilized
              //     ? { backgroundColor: "var(--primary-color)" }
              //     : { backgroundColor: "var(--green-color)" }
              // }
              // onChange={() => {}}
              disabled
            />
          </div>
        </div>
        <div className={styles.mobStatusCont}>
          <AntdDropDown
            trigger={"click"}
            menu={{
              items: items3,
            }}
            placement="bottomRight"
            arrow={{
              pointAtCenter: true,
            }}
          >
            <button className={styles.menubtn}>
              <SlOptionsVertical
                size={20}
                color="var(--light-text)"
                cursor={"pointer"}
              />
            </button>
          </AntdDropDown>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.tableDiv}>
      {/* <div className={styles.cars}>{cars.map((item) => rendercars(item))}</div> */}
      <Table
        //   title={}
        scroll={{ x: true }}
        bordered={false}
        pagination={false}
        columns={columns}
        dataSource={SingleAssets}
        onRow={(record, rowIndex) => {
          return {
            onClick: () => {
              //   setDetails(record);
              //   setOpen(true);
            },
            style: { cursor: "pointer" },
          };
        }}
      />
      <Drawer
        width={width < 550 ? "100%" : 600}
        headerStyle={{ display: "none" }}
        onClose={() => {
          setOpen(false);
          //   setDetails([]);
        }}
        open={open}
      >
        {/* <div className={styles.drawerImgDiv}> */}
        {/* <img src={c6} className={styles.drawerImg} /> */}
        <div
          className={styles.crossIconDiv}
          onClick={() => {
            setOpen(false);
            // setDetails([]);
          }}
        >
          <IoClose />
          {/* </div> */}
        </div>
        <div className={styles.rightCol}>
          <Card className={styles.card}>
            <div className={styles.header}>
              <TextComponent text={"Schedule"} className={styles.heading} />
              <div
                className={styles.btnScedule}
                onClick={() => setScheduleModal(true)}
              >
                <TextComponent text={"Add"} />
                <AiFillPlusCircle
                  size={18}
                  style={{ marginLeft: "5px" }}
                  color="var(--primary-color)"
                />
              </div>
            </div>

            <List dataSource={schedule} renderItem={renderItemScedule} />
          </Card>
        </div>
      </Drawer>
      <ScheduleModal
        scheduleModal={scheduleModal}
        setScheduleModal={setScheduleModal}
      />
      <EditScheduleModal
        scheduleModal={editScheduleModal}
        setScheduleModal={setEditScheduleModal}
      />
    </div>
  );
};

export default ModuleControl;
